import React from "react";

const Embedeb = () => {
  return (
    <div className="container overflow-hidden">
    <h1 className=" text-white bg-dark opacity-75 my-5 text-center   rounded py-3">
    CARR <span className="text-warning">VANA</span>
      </h1>
      
      
        <iframe width="560" height="315" src="https://www.youtube.com/embed/QbMC3phsVu4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
    
  );
};

export default Embedeb;
